import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  sub?: string;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  id?: string;
};
export function SectionHeading({
  eyebrow,
  title,
  sub,
  tone = 'light',
  align = 'center',
  id
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className={`max-w-[780px] ${align === 'center' ? 'mx-auto text-center' : ''}`} data-id="element-169" data-mp="3k18ag6cofsjo">
      {eyebrow && <p className={`mb-3 font-display text-[12px] font-bold tracking-[0.16em] ${dark ? 'text-gold' : 'text-orange-ink'}`} data-id="element-170" data-mp="bkvkz0aob30q">
          {eyebrow}
        </p>}
      <h2 id={id} className={`font-display text-[1.65rem] font-extrabold uppercase leading-[1.12] tracking-tight sm:text-[2.2rem] md:text-[2.6rem] ${dark ? 'text-white' : 'text-teal'}`} data-id="element-171" data-mp="1v3jrn82jbna">
        {title}
      </h2>
      {sub && <p className={`mt-4 text-[16px] leading-relaxed md:text-[17px] ${dark ? 'text-white/80' : 'text-ink/75'}`} data-id="element-172" data-mp="uh4vxeqa3dgi">{sub}</p>}
    </div>;
}